import { CircleAlert, CheckCircle2 } from 'lucide-react';
import { useEmergencyAlarm } from '../hooks/useEmergencyAlarm';
import type { EmergencyAlert } from '../services/api';

type IncomingAlertProps = {
  alert: EmergencyAlert | null;
  isAcknowledging: boolean;
  onAcknowledge: () => void;
};

export function IncomingAlert({ alert, isAcknowledging, onAcknowledge }: IncomingAlertProps) {
  const { audioStatus, startAlarm, stopAlarm } = useEmergencyAlarm(Boolean(alert));

  if (!alert) {
    return null;
  }

  function handleAcknowledge() {
    stopAlarm();
    onAcknowledge();
  }

  return (
    <div className="overlay incoming-overlay" role="alertdialog" aria-modal="true" aria-labelledby="incoming-title">
      <div className="confirm-sheet incoming-sheet">
        <span className="permission-icon danger">
          <CircleAlert size={28} aria-hidden="true" />
        </span>
        <div>
          <p className="panel-kicker">Incoming emergency</p>
          <h2 id="incoming-title">SOS from {alert.sender}</h2>
          <p>Emergency alert received at {new Date(alert.createdAt).toLocaleTimeString()}.</p>
          <p className="alarm-status">
            In-app alarm: {audioStatus === 'playing' ? 'playing' : audioStatus === 'blocked' ? 'tap Start alarm' : audioStatus}
          </p>
        </div>
        {audioStatus === 'blocked' || audioStatus === 'idle' ? (
          <button className="secondary-button full-width" type="button" onClick={startAlarm}>
            Start alarm
          </button>
        ) : null}
        <button className="danger-button full-width" type="button" onClick={handleAcknowledge} disabled={isAcknowledging}>
          <CheckCircle2 size={18} aria-hidden="true" />
          {isAcknowledging ? 'Acknowledging...' : 'I saw this alert'}
        </button>
      </div>
    </div>
  );
}
